// @charset "utf-8";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import dialog from '@/components/lib/dialog'
import pagination from '@/components/lib/pagination'
// import select from '@/components/lib/select'
// import multibox from '@/components/lib/multibox'
// import selectinput from '@/components/lib/selectinput'
import loading from '@/components/lib/loading'
import button from '@/components/lib/button'
import noticeTip from '@/components/lib/notice-tip'

// import empty from '@/components/lib/empty'
import tipVue from './tipVue'
import confirmVue from './confirmVue'
import clickOutside from './clickOutside'
import dataValidation from './dataValidation'
import './axiosConfig'
// import './HighchartsConfig'
import './filter'
import staticText from './staticText'
import buriedPoint from './buriedPoint'

// Vue.config.productionTip = false
// Vue.component('vue-dialog', dialog)
Vue.component('vue-pagination', pagination)
// Vue.component('vue-select', select)
Vue.component('vue-loading', loading)
// Vue.component('vue-empty', empty)
// Vue.component('vue-multibox', multibox)
// Vue.component('vue-selectinput', selectinput)
Vue.component('vue-button', button)
Vue.component('vue-notice-tip', noticeTip)

Vue.prototype.$tip = tipVue
Vue.prototype.$staticText = staticText
Vue.prototype.$buriedPoint = buriedPoint
Vue.prototype.$confirm = confirmVue

// 中央事件总线
Vue.prototype.$Bus = new Vue()
// /* eslint-disable no-unused-vars */
// Vue.prototype.goCode = (code) => {
//     try {
//         // 验证是否有客户端
//         var gHexinApiQuote = external.createObject('Quote')

//         let stock = code.slice(0, 6)
//         let url = "hxa://hexin.exe 'opt=13&param=" + stock + "'"
//         location.href = url
//     } catch (exp) {
//         Vue.prototype.$tip({message: '该功能需要客户端支持', type: 'warning'})
//     }
// }

Vue.prototype.codeLink = (stockCode) => {
    let stock = stockCode.slice(0, 6)
    try {
        /* eslint-disable no-unused-vars */
        var hexinApi = external.createObject('Quote')
        location.href = "hxa://hexin.exe 'opt=13&param=" + stock + "'"
    } catch (exp) {
        window.open('//x.10jqka.com.cn/stockpick/search?tid=stockpick&qs=stockpick_diag&ts=1&w=' + stock)
    }
}
Vue.directive('click-outside', clickOutside)
Vue.directive('validate', dataValidation)

Vue.prototype.$mousemoveEvent = null
document.body.addEventListener('mousemove', function (event) {
    Vue.prototype.$mousemoveEvent = event
}, false)



// WEBPACK FOOTER //
// ./src/lib/vueGlobalConfig.js